import React from "react";
import ClapInvoices from "../../components/_shared/ClapInvoices";

const Invoices = () => {
  return <ClapInvoices />;
};

export default Invoices;
